import { ButtonHTMLAttributes } from 'react'

import { StyledCommonButton } from './styles'

export type ButtonVariants =
  | 'darkOutlined' // TODO: remove after login
  | 'errorFilled' // TODO: remove after login
  | 'primary'
  | 'secondary'

export type ButtonSizes = 'small' | 'big'

export interface CommonButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariants
  size?: ButtonSizes
}

export default StyledCommonButton
